// src/lib/motion/springConfigs.ts — Central spring configuration

export const SpringConfigs = {
  micro:     { stiffness: 400, damping: 35, mass: 1 },     // 80-120ms — button tap, hover, state change
  default:   { stiffness: 300, damping: 25, mass: 1 },     // 200-350ms — nav, card, modal
  bounce:    { stiffness: 200, damping: 15, mass: 1 },     // 250-400ms — sidebar, fun reveals
  smooth:    { stiffness: 150, damping: 20, mass: 1.2 },   // 300-500ms — coach message, breathing
  weighted:  { stiffness: 250, damping: 35, mass: 1.8 },   // 400-700ms — heavy, dramatic
  celebrate: { stiffness: 120, damping: 18, mass: 2 },     // 600-1400ms — achievement, PR, unlock
  impact:    { stiffness: 500, damping: 50, mass: 1 },     // 16-50ms — hold at peak
} as const;

export type SpringConfigName = keyof typeof SpringConfigs;

// Duration bands (hard limits for non-spring CSS transitions)
export const DurationBands = {
  microFeedback:      { min: 80, max: 120 },    // button tap, hover
  quickTransition:    { min: 150, max: 200 },   // small modal, tooltip
  standardTransition: { min: 200, max: 350 },   // nav, card, modal
  guidedInteraction:  { min: 300, max: 450 },   // coach message, breathing
  celebration:        { min: 500, max: 1200 },  // achievement, PR, unlock
  impactFrame:        { min: 16, max: 50 },     // hold at peak
  countUp:            { min: 600, max: 1200 },  // score reveal, rank update
  pageTransition:     { min: 250, max: 400 },   // screen-to-screen
} as const;

// Stagger timing
export const StaggerTiming = {
  list: { delayChildren: 0.08, staggerChildren: 0.04 },  // 80ms delay, 40ms per item
  grid: { delayChildren: 0.08, staggerChildren: 0.025 }, // 80ms delay, 25ms per row
  fast: { delayChildren: 0.05, staggerChildren: 0.03 },  // social feed, rapid lists
  slow: { delayChildren: 0.1,  staggerChildren: 0.06 },  // skill tree, dramatic reveals
} as const;
